/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(['./Rave2bundlebar'], function(Rave2bundlebar) {
	'use strict';

	class Rave2bundlecolumn extends Rave2bundlebar{
		constructor(){
			super();
		}
		get config(){
			const config = super.config;
			config.type = 'Column';
			config.slots.categories.icon = 'x-axis_bars';
			config.properties['bar.direction.vertical'].defaultValue = true;

			delete config['isItemAxisYAxis'];
			delete config.properties['itemAxis.labels.layoutMode'];
			config.config.include.push('color.title.visible');

			return config;
		}
	}

	return Rave2bundlecolumn;
});